import React from 'react';
import {
	Descriptions,
	Drawer,
	PreLoader,
	Skeleton,
	Typography,
	Table,
} from '@/elements';
import moment from 'moment';
import defaultAvatar from '@/elements/avatar/default-avatar.svg';
import { timeFormat } from '../grid-cards';
import { Link } from 'react-router-dom';
import { Tooltip } from 'antd';

const { Text, Title, Paragraph } = Typography;

// helper func
const columns = [
	{
		title: 'Date',
		dataIndex: 'date',
	},
	{
		title: 'Start',
		dataIndex: 'start',
	},
	{
		title: 'End',
		dataIndex: 'end',
	},
	{
		title: 'Site',
		dataIndex: 'site',
		width: 80,
		render: text => (
			<div
				style={{
					textOverflow: 'ellipsis',
					overflow: 'hidden',
					whiteSpace: 'nowrap',
					maxWidth: '80px',
					cursor: 'pointer',
				}}
				onClick={e => {
					e.stopPropagation();
					return false;
				}}
			>
				<Tooltip title={text} placement="topRight">
					{text}
				</Tooltip>
			</div>
		),
	},
];

function getHistory(data, sitesList) {
	if (data) {
		return data.map((el, i) => ({
			key: i,
			date: `${moment(el.startTime).format('DD-MM-YYYY')}`,
			site: sitesList.find(site => el.siteId === site.siteId).description,
			// site: 'long site name, _)(*&^%$#@!#$%^&*()(*&^%$',
			start: `${moment(el.startTime).format('HH:mm')}`,
			end: `${moment(el.endTime).format('HH:mm')}`,
		}));
	}
}

const HolderDrawer = React.memo(function HolderDrawer({
	currentHolder,
	loading,
	visible,
	handleDrawerClose,
	visits,
	sitesList,
	clientId,
	showZone,
}) {
	/* only rerenders if props change */
	const renderDrawerHead = () => {
		const { imagePath, clientReference } = currentHolder;
		return (
			<div
				className="modalHolder-img"
				style={{
					backgroundImage: imagePath
						? `url(${process.env.REACT_APP_AWS_S3_PATH}${imagePath})`
						: `url(${defaultAvatar})`,
				}}
			>
				{loading && <PreLoader />}
				{/*<div className="holderId">ID: {clientReference}</div>*/}
			</div>
		);
	};

	return (
		<Drawer
			className="holderDrawer"
			title={renderDrawerHead()}
			visible={visible}
			onClose={handleDrawerClose}
			footer={null}
			placement="right"
			width={320}
			getContainer={'.main-content-container'}
		>
			<Skeleton loading={loading} active>
				{currentHolder && (
					<React.Fragment>
						<div className="holderInfo">
							<Title ellipsis level={4}>
								<Link
									to={`/directory/${currentHolder.clientReference}`}
								>
									{currentHolder.name}
								</Link>
							</Title>
							{currentHolder.metadata && (
								<Descriptions
									title={null}
									size="small"
									column={24}
								>
									{Object.entries(currentHolder.metadata)
									.filter(([key]) => {
										if (clientId === 'gleneagles' && key === 'DoB') {
										return false;
										}
										return true;
									})
									.map(([key, value]) => (
										<Descriptions.Item
										key={key}
										label={<Text>{key}</Text>}
										span={24}
										>
										<Text className="desc-val">{value}</Text>
										</Descriptions.Item>
									))}
								</Descriptions>
								)}
							{currentHolder.note && [
								<div key="title">
									<b>Notes</b>
								</div>,
								<Paragraph
									key="note"
									ellipsis={{ rows: 3, expandable: true }}
								>
									{currentHolder.note}
								</Paragraph>,
							]}
							{currentHolder.detectionTime && clientId !== 'gleneagles' && [
								<div key="title">
									<b>Last seen</b>
								</div>,
								<Paragraph key="time">
									{moment(currentHolder.detectionTime).format(
										timeFormat,
									)}{' '}
									on{' '}
									{moment(currentHolder.detectionTime).format(
										'DD-MM-YYYY',
									)}
									<br />
									<Text>
										{`at ${currentHolder.siteName}`}
										{showZone &&
											`, ${currentHolder.zoneName}`}
									</Text>
								</Paragraph>,
							]}
							{currentHolder.thermalAlert && [
								<div key={'title'}>
									<b>Abnormal Temperature detected.</b>
								</div>,
								<Paragraph key={'temperature'}>
									<Text>
										Measured temperature is{' '}
										{
											currentHolder.thermalAlert
												.currTemperature
										}{' '}
										while allowed temperature has to be
										below{' '}
										{
											currentHolder.thermalAlert
												.ruleTemperature
										}
									</Text>
								</Paragraph>,
							]}
							{sitesList &&
								sitesList.length > 0 &&
								visits &&
								visits.length > 0 && clientId !== 'gleneagles' && (
									<React.Fragment>
										{/*<div key="title">*/}
										{/*	<b>Recent visits</b>*/}
										{/*</div>*/}
										{/*{visits.map((el, i) => (*/}
										{/*	<div key={i} className={'history-item'}>*/}
										{/*		<div>*/}
										{/*			<Text className="desc-label">*/}
										{/*				<span>Site:</span>*/}
										{/*				{*/}
										{/*					sitesList.find(*/}
										{/*						site =>*/}
										{/*							el.siteId ===*/}
										{/*							site.siteId,*/}
										{/*					).description*/}
										{/*				}*/}
										{/*			</Text>*/}
										{/*		</div>*/}
										{/*		<div>*/}
										{/*			<Text className="desc-label">*/}
										{/*				<span>Start: </span>*/}
										{/*				{moment(*/}
										{/*					el.startTime,*/}
										{/*				).format('DD-MM-YYYY')}*/}
										{/*				{` at `}*/}
										{/*				{moment(*/}
										{/*					el.startTime,*/}
										{/*				).format('HH:mm')}*/}
										{/*			</Text>*/}
										{/*		</div>*/}
										{/*		<div>*/}
										{/*			<Text className="desc-label">*/}
										{/*				<span>End: </span>*/}
										{/*				{moment(el.endTime).format(*/}
										{/*					'DD-MM-YYYY',*/}
										{/*				)}*/}
										{/*				{` at `}*/}
										{/*				{moment(el.endTime).format(*/}
										{/*					'HH:mm',*/}
										{/*				)}*/}
										{/*			</Text>*/}
										{/*		</div>*/}
										{/*	</div>*/}
										{/*))}*/}
										<Table
											columns={columns}
											dataSource={getHistory(
												visits,
												sitesList,
											)}
											// size="small"
											bordered={false}
											pagination={false}
										/>
									</React.Fragment>
								)}
						</div>
					</React.Fragment>
				)}
			</Skeleton>
		</Drawer>
	);
});

export default HolderDrawer;



// WEBPACK FOOTER //
// ./src/pages/live-view/components/holder-drawer/index.js